define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/reflection",
	"csi/table/Widget",
	"SiteAdmin/Locale",
	"./_Store",
	"./_TableMixin"
], function(declare, csi, _, reflection, Table, Locale, _Store, _TableMixin) {

	var _ViewResourceStore = declare(_Store, {
		getResourceAttribute: function() {
			// summary: return attribute
			return Locale.ATTR_VIEWS;
		},

		getResourceKeys: function(/*Node*/node, /*String*/keyContainer) {
			// summary: return [type, view, key]
			return [node.Type, node.View, node.Id];
		},

		_getResource: function(/*Node*/node, /*LocaleResolver*/lr) {
			// summary: get resource for key from resolver
			return lr.getTypeViewResource(node.Type, node.View, node.Id);
		},

		_resolveData: function(/*Deferred*/dfd) {
			// summary: create node per resource that is not enumeration
			var lr = this.lrBaseSite;
			var data = [];

			_.each(lr.localeResources.views, function(typeObj, type) {
				// only show enabled classes with an explicit name
				var rc = reflection.getClass(type);
				if (rc?.enabled) {
					var typeName = lr.getTypeName(type);

					_.each(typeObj, function(viewObj, view) {
						var viewName = lr.getTypeView(type, view);

						_.each(viewObj, function(value, key) {
							data.push(this._createNode(key, {
								Sort: typeName + "." + viewName + "." + key,
								Type: type,
								TypeName: typeName,
								View: view,
								ViewName: viewName
							}));
						}, this);
					}, this);
				}
			}, this);

			dfd.resolve(csi.sort(data, "Sort"));
		}
	});

	return declare([Table, _TableMixin], {
		storeClass: _ViewResourceStore
	});
});
